import React, { useState } from 'react'
import HeaderCompo from '../../component/Header'
import { Table } from 'antd'

const data = [
    {
        name:"GCR",
        def:`Generic Compliance Ratio. \nGeneric Rx $ divided by Total Rx $ (not including HIV).`
    },
    {
        name:"SGCR",
        def:"Scrubbed Generic Compliance Ratio. \nGeneric Rx $ divided by Total Rx $ (Not including GLP-1, Specialty or HIV)."
    },
    {
        name:"GPR",
        def:"Generic Purchase Ratio. \n This metric is calculated by dividing your total spend on generic tablets and capsules by the total number of generic tablets and capsules dispensed.\n The information used to calculate this figure is obtained through a data consent form submitted to McKesson, which authorizes them to access and review your dispensing data."
    },
    {
        name:"COGs",
        def:"Cost of Goods. \n The discount off WAC on Brand Rx purchases calculated based on your GCR compliance tier achieved in the previous quarter."
    },
    {
        name:"COGs Impact",
        def:"The difference between Current COGs and Trending COGs and is based upon your last quarter's rebatable brand."
    },
    {
        name:"Trending COGs",
        def:"Based on the current quarter's GCR, allowing you to view where your COGs are trending for next quarter."
    },
    {
        name:"Current COGs",
        def:"Your pharmacy's current percentage off of WAC for Brand Rx based on last quarters GCR%.  (Not including GLP1, Specialty or HIV).  The new COGs goes into effect one month after the end of the quarter."
    },
]
const DataDictionary = () => {
    const [pagination,setPagination] = useState(10)
    const column = [
    {
      title: "Acroynm",
      dataIndex: "name",
      key: "name",
      render: (text) => text || "-",
    },
    {
      title: "Definition",
      dataIndex: "def",
      key: "def",
      render: (text) => <div style={{ whiteSpace: "pre-line" }}>{text || "-"}</div>
    },
    ]
  return (
    <div>
       <HeaderCompo initialColor={'#000833'} />
       <div className='m-3'>
        <div className='text-[20px] font-semibold m-4'>Data Dictionary</div>
        <Table
          columns={column}
          dataSource={data}
          scroll={{ x: "max-content" }}
          rowKey="id"
          size="middle"
          //   loading={isLoading}
          className="custom-table user-tbl"
          pagination={false}
          />
        </div>
    </div>
  )
}

export default DataDictionary
